export default (siteKey) => ({
  recaptchaToken: '',
  verifyRecaptcha: function (event) {
    event.preventDefault()
    const form = this
    grecaptcha.ready(function () {
      grecaptcha
        .execute(siteKey, { action: 'submit' })
        .then(function (token) {
          form.recaptchaToken = token;
          form.$nextTick(() => { form.$dispatch('recaptchaVerified') });
        });
    });
  }
});
